import { rentalYield } from "../../engine/calculations";

const config = {
  key: "property-rental-yield",
  title: "Property Rental Yield",
  category: "Wealth Strategies",
  description: "See the gross and net rental yield a property is earning you.",
  fields: [
    { key: "propertyValue", label: "Property value", type: "currency", default: 80_00_000, min: 1_00_000, max: 50_00_00_000 },
    { key: "monthlyRent", label: "Monthly rent", type: "currency", default: 30_000, min: 0, max: 50_00_000 },
    { key: "annualExpenses", label: "Annual expenses", type: "currency", default: 40_000, min: 0, max: 50_00_000, help: "Maintenance, property tax, insurance, etc.", optional: true },
  ],
  compute(values) {
    const propertyValue = Number(values.propertyValue) || 0;
    const monthlyRent = Number(values.monthlyRent) || 0;
    const annualExpenses = Number(values.annualExpenses) || 0;

    const result = rentalYield(propertyValue, monthlyRent, annualExpenses);

    return {
      headline: { label: "Gross rental yield", value: result.grossYield, format: "percent" },
      extraHeadlines: [{ label: "Net rental yield", value: result.netYield, format: "percent" }],
      breakdown: [
        { label: "Annual rent", value: result.annualRent },
        { label: "Annual expenses", value: annualExpenses },
      ],
    };
  },
};

export default config;
